import { useState, memo } from 'react'

interface ProjectLogoProps {
  logo?: string | null
  color: string
  alt: string
}

export const ProjectLogo = memo(({ logo, color, alt }: ProjectLogoProps) => {
  const [imgError, setImgError] = useState(false)
  
  return (
    <div 
      className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
      style={{ backgroundColor: color || '#949494' }}
    >
      {!imgError && logo ? (
        <img
          src={logo}
          alt={alt}
          className="w-7 h-7 rounded-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="text-[10px] font-medium text-white">
          {alt.charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  )
})

ProjectLogo.displayName = 'ProjectLogo'

